/* eslint-disable react/jsx-curly-brace-presence */
import React from 'react';
import PropTypes from 'prop-types';
import Box from 'ui-box';
import { Row, Typography } from 'antd';

const { Title } = Typography;

const styles = {
  menutItem: {
    width: '100%',
    border: "1px solid #C0C0C0",
    boxSizing: "border-box",
    borderRadius: "2px",
    padding: "14px 24px",
    marginBottom: 20
  },
  hoverMenu: {
    width: '100%',
    border: "1px solid #C0C0C0",
    boxSizing: "border-box",
    borderRadius: "2px",
    padding: "14px 24px",
    backgroundColor: '#DCF2FB',
    color: '#FFF',
    marginBottom: 20
  },
  menuTitle: {
    fontWeight: "300",
    fontSize: "16px",
    lineHeight: "24px",
    textTransform: "capitalize",
    color: "#404047",
    margin: 0,
    marginLeft: 10
  }
}

function HomeMenuList({icon, title, isSelected, onClick}) {
  return (
    <Box
      style={isSelected ? styles.hoverMenu : styles.menutItem}
      onClick={!isSelected ? onClick : () => {}}
    >
      <Row justify="start" align="middle">
        {
          icon !== null && icon
        }
        <Title level={4} style={styles.menuTitle}>
          {title}
        </Title>
      </Row>
    </Box>
  );
}

HomeMenuList.defaultProps = {
  icon: null,
  isSelected: false,
};

const { string, element, bool, func } = PropTypes;

HomeMenuList.propTypes = {
  title: string,
  icon: element,
  isSelected: bool,
  onClick: func,
};

export default HomeMenuList;
